import type { FeatureId,Summary } from "./types";
export const modules:{id:FeatureId;label:string;description:string;plans:string}[]=[
 {id:"after_hours",label:"Fuera de horario",description:"Recoge mensajes cuando el negocio está cerrado.",plans:"Todos los planes"},
 {id:"appointments",label:"Citas",description:"Agenda, confirma y recuerda citas automáticamente.",plans:"Estándar y Completo"},
 {id:"faq",label:"Preguntas frecuentes",description:"Responde usando información aprobada por tu negocio.",plans:"Todos los planes"},
 {id:"post_service",label:"Seguimiento",description:"Satisfacción, reseñas y gestión de quejas.",plans:"Plan Completo"},
];
export function moduleCards(summary:Summary){
 return modules.map(module=>({...module,enabled:summary.capabilities.features[module.id]}));
}
export function alertCount(summary:Summary){
 return summary.alerts.messagesNew+summary.alerts.openComplaints+summary.alerts.unresolvedDelivery;
}
